import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import AdminProject from "@/pages/AdminProject";
import PortalNotFound from "@/pages/PortalNotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortalNotFound />} />
          <Route path="/portal/:slug" element={<Portal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/projects/:id" element={<AdminProject />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "#2E2E2C", color: "#EEFF00", border: "none", borderRadius: 20,
                   fontFamily: "DM Sans, sans-serif", fontSize: "13px", letterSpacing: "0.05em" },
        }}
      />
    </div>
  );
}

export default App;
